<template>
<div>
<div  v-if="ishide">
 <div  v-if="!isHidden"  class="container mx-auto">
      <div style="background-color: #abf3dc;padding-top: 15px;padding-bottom: 15px;padding-right: 10px;padding-left: 8px;" class="mx-4 my-6">
<table style="width:100%"><tr>
       <td style="width:95%;font-color:black">{{itemmess}}</td>
   <td style="width:5%">
    <button v-on:click="isHidden = !isHidden" style="background-color: #abf3dc;padding-top: 5px;padding-bottom: 1px;padding-right: 5px;padding-left: 5px;" ><doe-icon icon="times" /></button>
     
   </td>
       </tr></table>

      </div>
      </div>
  </div>
    <div class="container mx-auto">
      <div class="mx-4 my-6">
        <doe-image-banner label="Welcome to the Self-Assessment and Quality Improvement Planning Portal" image="Portal-img.jpg" >
          <p class="font-sans text-blue-900 mt-2">
            The Self Assessment and Quality Improvement Planning portal provides anytime access for approved education and care services to easily document their quality improvement journey. 
          </p>
          <p class="font-sans text-blue-900 mt-2">
            As a user of the Self Assessment and Quality Improvement Planning portal you will be able to record information relating to your service philosophy, compliance with Law and Regulations, key practices aligned to the National Quality Standard and maintain an up to date improvement plan.
          </p>
          <div class="flex my-4">
            <div class="flex-1 pr-2">
              <h3 class="block font-sans font-semibold leading-snug max-w-4xl subpixel-antialiased text-lg text-blue-900 lg:leading-snug">Login</h3>
              <p class="font-sans text-blue-900 my-2 text-sm pr-2">Existing Department of Education account holders.</p>
              <doe-button
                class="mb-4 md:mb-0"
                label="Login"
                appearance="primary"
                action="form:login"
                @click="login()"
              />
            </div>
            <div class="flex-1">
              <h3 class="block font-sans font-semibold leading-snug max-w-4xl subpixel-antialiased text-lg text-blue-900 lg:leading-snug">Register</h3>
              <p class="font-sans text-blue-900 my-2 text-sm">Approved providers and nominated supervisors only.</p>
              <doe-button
                class="mb-4 md:mb-0"
                label="Create an account"
                appearance="secondary"
                action="form:register"
                @click="register()"
              />
            </div>          
          </div>
            <div class="md:flex mx-4" style="border-style: solid;  border-width: 2px;padding-left:0px;">
             <span  style="float:left; padding-left:0px;"><b>For guidance on using the portal, you might like to refer to our  <a href="https://education.nsw.gov.au/early-childhood-education/regulation-and-compliance/assessment-and-rating/self-assessment/self-assessment-and-quality-improvement-planning-portal-videos"  target="_blank" class="no-underline mt-3">
            
            <u>instructional videos</u> </a> or the user guide accessible once logged into the portal.</b></span>
            </a>
         
            </div>
        </doe-image-banner>
      </div>

      <div class="md:flex mx-4">
        <div class="md:w-1/3 md:pr-2 mb-4 md:mb-0">
          <doe-banner class="h-full" label="Self-Assessment">
            <p class="font-sans text-blue-900 mt-2">
              Self Assessment is a cycle which provides the opportunity for services to identify and review key practices occurring at the service in line with the National Quality Standards. The self assessment cycle allows you to identify WHAT you do and WHY you do it. 
            </p>
            <p class="font-sans text-blue-900 mt-2">
              Self Assessment is a requirement under Element 7.2.1 of the National Quality Standard which directly refers to self-assessment and continuous improvement.
            </p>
          </doe-banner>
        </div>
        <div class="md:w-1/3 md:px-2 mb-4 md:mb-0">
          <doe-banner class="h-full" label="Improvement planning">
            <p class="font-sans text-blue-900 mt-2">
              The Self Assessment and Quality Improvement Planning Portal allows services to identify and enter any goals or improvement areas they are working on in each quality area.
            </p>
            <p class="font-sans text-blue-900 mt-2">
              Services are encouraged to be realistic and authentic about their goals and continuous improvement journey, and focus on current areas of focus.
            </p>
          </doe-banner>
        </div>
        <div class="md:w-1/3 md:pl-2">
          <doe-banner class="h-full" label="Self Assessment and Quality Improvement Planning Portal Vs Quality Improvement Plan">
            <p class="font-sans text-blue-900 mt-2">
              Services using the NSW Self Assessment and Quality Improvement Planning Portal meet the requirements of Regulation 55. The portal also allows services to easily submit information to the regulatory authority on request.
            </p>
          </doe-banner>
        </div>

      </div>


      <div class="mx-4 my-8">
        <doe-fieldset-heading
          label="What is the Self Assessment and Quality Improvement Planning Portal and why is this beneficial?"
          :description="[
            'The Self-Assessment and Quality Improvement Planning Portal provides an opportunity for services to record, track and update their self-assessment cycle and quality improvement processes through a live environment, which is always available online.',
            'Through the Self-Assessment and Quality Improvement Planning Portal, Early Childhood Education (ECE) services record their philosophy, and reflect through their regulatory compliance, strengths and key practices, documenting areas of improvement and outcomes as part of the service’s quality improvement processes. This allows the service to measure their practices against the requirements of the National Quality Standards alongside the requirements of the Education and Care Services National Law and Regulations.',
            'When contacted by the Regulatory Authority to advise of the Assessment and Rating process commencing, the service will be able to easily release information contained in the Self-Assessment and Quality Improvement Planning Portal to the Authorised Officer for review prior to the visit.'
          ]"
        />
      </div>

      <div class="mx-4 my-8">
        <doe-fieldset-heading
          label="Accessing the Self-Assessment and Quality Improvement Planning Portal"
          :description="[
            'You will need to create a Department of Education (DoE) account to access the Self-Assessment and Quality Improvement Planning Portal. Centre directors or nominated supervisors need to begin this process by clicking \'create an account\' below.',
            'If you are an early childhood educator, please contact your centre director to request access.'
          ]"
        />
      </div>


      <div class="md:flex mx-4">
        <div class="md:w-1/3 md:pr-2 mb-4 md:mb-0 flex-1">
          <doe-banner
            label="Login"
            description="Existing Department of Education (DoE) account holders."
            buttonLabel="Login"
            action="form:login"
            @click="login()"
          />
        </div>
        <div class="md:w-1/3 px-4 md:px-6 py-4  flex-1">
          <doe-fieldset-heading
            class="mb-4 md:ml-2"
            style="width: 88%;"
            label="Register"
            description="Approved providers and nominated supervisors only."
          />
          <doe-button
            class="md:ml-2"
            label="Create an account"
            appearance="secondary"
            action="form:register"
            @click="register()"
          />
        </div>     
      </div>    
    </div>
  </div>
</template>

<script>
import schema from "@/schemas/landing";
import DoeImageBanner from "@/components/banner/ImageBanner";
import DoeBanner from "@/components/banner/Banner";
import DoeFieldsetHeading from "@/components/typography/FieldsetHeading";
import DoeButton from "@/components/button/Button";
import DoeIcon from "@/components/icon/Icon.vue";
import axios from 'axios';

export default {
  name: "landing",
  components: {
    DoeImageBanner,
    DoeBanner,
    DoeFieldsetHeading,
     DoeIcon,
    DoeButton
  },
  data() {
    return {
      schema: schema,
      itemmess: "",     
        isHidden: false ,
        ishide: false
    };
  },
  methods: {
    login() {
      this.$router.push({ name: "onboarding-services" });
    },
    register() {
      this.$router.push({ name: "register-onboarding" });
    },
    setup() {
    const portalmessId ='PORTL000012';   
    let URL = window.config.serverUrl + '/api/portal-message/PORTL000012'
    axios.get(URL).then((response) => {
    this.itemmess = response.data.messageDets;
    if(response.data.messageDets && response.data.messageDets.length > 0){
      this.ishide =true;
      //this.isHidden = true;
    }
       // console.log("hello", JSON.stringify(response.data.messageDets));
    });
  }
  },
   mounted() {
    this.setup();
  },
};
</script>

<style lang="scss" scoped></style>
